import ArrayUtils from "./array";
import { DateTime } from "luxon";

export const fromObject = (obj: {
  year: number;
  month: number;
  day: number;
}): DateTime => DateTime.fromObject({ ...obj, zone: "UTC" });

export const monthCalendar = (year: number, month: number): DateTime[][] => {
  const date = fromObject({ year, month, day: 1 });
  const firstDay = date.startOf("month").weekday % 7;
  const lastDay = date.endOf("month").weekday % 7;

  const lastMonth = date.minus({ months: 1 });
  const daysInLastMonth = lastMonth.daysInMonth;
  const lastMonthDays = ArrayUtils.range(
    daysInLastMonth - firstDay,
    daysInLastMonth
  ).map((i): DateTime => lastMonth.set({ day: i + 1 }));

  const daysInMonth = date.daysInMonth;
  const thisMonthDays = ArrayUtils.range(daysInMonth).map(
    (i): DateTime => date.set({ day: i + 1 })
  );

  const nextMonth = date.plus({ months: 1 });
  const nextMonthDays = ArrayUtils.range(7 - lastDay - 1).map(
    (i): DateTime => nextMonth.set({ day: i + 1 })
  );

  return ArrayUtils.grouped(
    [...lastMonthDays, ...thisMonthDays, ...nextMonthDays],
    7
  );
};

export const parseDate = (dateString: string): DateTime =>
  DateTime.fromISO(dateString, { zone: "UTC" });

export const fromSeconds = (seconds: number): DateTime =>
  DateTime.fromSeconds(seconds, { zone: "UTC" });

export const today = (): DateTime => {
  const now = DateTime.now();
  return fromObject({
    year: now.year,
    month: now.month,
    day: now.day,
  });
};
